import React from 'react'
import { Text } from 'pcln-design-system'
import { User as UserIcon } from 'pcln-icons'
import { StyledMenuButton, StyledInput } from './Elements.styled'

type MenuProp = {
  isPanelOpen: boolean
  hasError: boolean
  label: string
  isMobile: boolean
  disabled: boolean
  toggleMenu: (isPanelOpen: boolean) => void
}

export default function Menu({
  isPanelOpen = false,
  hasError = false,
  label = '',
  toggleMenu,
  disabled,
  isMobile
}: MenuProp) {
  return (
    <StyledMenuButton
      disabled={disabled}
      type="button"
      color="text.lightest"
      width={1}
      isMobile={isMobile}
      onClick={toggleMenu(isPanelOpen)}
      aria-label="traveler-selection-control-panel"
      aria-expanded={isPanelOpen}
      aria-controls="traveler-selection-control-panel"
      borderRadius="lg"
    >
      <UserIcon color="primary" size={24} mx={10} />
      <Text fontSize={1} fontWeight={500}>
        {label}
      </Text>
      <StyledInput
        readOnly
        type="text"
        tabIndex={-1}
        aria-live="polite"
        borderRadius="lg"
        aria-atomic="true"
        aria-label="traveler selection"
        color={!isPanelOpen && hasError ? 'warning' : undefined}
      />
    </StyledMenuButton>
  )
}
